import createActionType from "../../utils/createActionType";

export const MODULE = "pdf-customisation/template-lists";

export const SET_IS_FETCHING_TEMPLATES_STATUS = createActionType(
  MODULE,
  "setIsFetchingTemplatesStatus"
);

export const SET_TEMPLATES = createActionType(MODULE, "setTemplates");

export const SET_IS_SELECT_TEMPLATE_MODAL_VISIBLE = createActionType(
  MODULE,
  "setIsSelectTemplateModalVisible"
);

export const SET_LOADING_STATE = createActionType(MODULE, "setLoadingState");

export const SET_LOADING_STATE_BY_UID = createActionType(MODULE, "setLoadingStateByUid");

export const SET_LOADING_STATE_ON_NEW_UID = createActionType(MODULE, "setLoadingStateOnNewUid");

export const RESET = createActionType(MODULE, "reset");
